// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"4":"10b685f6","43":"72e88e48","251":"8bd6f876","458":"6b202d6c","524":"02071883","547":"0e2c6848","730":"f5453c56","746":"bdccebad"}[chunkId] + ".chunk.js";
};